import React, { useEffect } from 'react'
import Navbar from './Navbar'
import Footer from '../Footer'
import CTA from '../CTA'

export default function Layout({
  data = undefined as any,
  children = <></>
}) {

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!localStorage.getItem(`land_url`)) {
        localStorage.setItem(`land_url`, window.location.href);
      }
    }
  }, []);

  return (
    <div style={{ zoom: 0.95 }}>
      <Navbar 
        data={data}
      />
      {children}
      <CTA />
      <Footer
        data={data}
      />
      <form name="waitlist" method="post" className='hidden' data-netlify="true">
        <input name='form-name' type='hidden' />
        <input name='name' type='hidden' />
        <input name='email' type='hidden' />
        <input name='message' type='hidden' />
        <input name='land_url' type='hidden' />
        <input name='document.referrer' type='hidden' />
      </form>
      <form name="newsletter" method="post" className='hidden' data-netlify="true">
        <input name='form-name' type='hidden' />
        <input name='email' type='hidden' />
        <input name='land_url' type='hidden' />
        <input name='document.referrer' type='hidden' />
      </form>
    </div>
  )
}
